import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import ReactQuill from 'react-quill';
import React from 'react';
import { theme } from '../../../../theme';

interface EditOfferLetterDialogProps {
  open: boolean;
  onCancel: () => void;
  onSave: () => void;
  quillRef: React.RefObject<ReactQuill>;
  editedEmailBody: string;
  setEditedEmailBody: (value: string) => void;
  errorMessage: string;
  setErrorMessage: (msg: string) => void;
  quillModules: any;
}

const EditOfferLetterDialog: React.FC<EditOfferLetterDialogProps> = ({
  open,
  onCancel,
  onSave,
  quillRef,
  editedEmailBody,
  setEditedEmailBody,
  errorMessage,
  setErrorMessage,
  quillModules,
}) => (
  <Dialog
    open={open}
    onClose={() => { }}
    disableEscapeKeyDown
    hideBackdrop={false}
    BackdropProps={{
      sx: {
        backgroundColor: 'rgba(0, 0, 0, 0.3) !important',
      },
      onClick: (e: React.MouseEvent) => {
        e.stopPropagation();
      },
    }}
    PaperProps={{
      sx: {
        maxWidth: '60.2vw',
        maxHeight: '44.8vw',
        width: '100%',
        height: '100%'
      },
    }}
  >
    <DialogTitle>
      <Typography variant='h5'>
        Edit Offer Letter
      </Typography>
      <Typography variant='caption'>
        Customize Offer Details, Compensation, and Joining Terms Before Sending to the Candidate
      </Typography>
    </DialogTitle>
    <DialogContent>
      <Box sx={{ display: 'flex', flexDirection: 'column', marginBottom: '2vw' }}>
        <ReactQuill
          ref={quillRef}
          theme="snow"
          value={editedEmailBody}
          onChange={(value) => {
            if (errorMessage) setErrorMessage('');
            setEditedEmailBody(value);
          }}
          modules={quillModules}
          style={{ width: '52.9vw', height: '28.2vw', marginBottom: '2vh' }}
        />
        {errorMessage && (
          <Typography color="error" variant="body2" sx={{ mt: 4, ml: 2 }}>
            {errorMessage}
          </Typography>
        )}
      </Box>
    </DialogContent>
    <DialogActions sx={{ bgcolor: theme.palette.primary.light }}>
      <Button variant='outlined' onClick={onCancel}>Cancel</Button>
      <Button onClick={onSave} variant="contained">Save</Button>
    </DialogActions>
  </Dialog>
);

export default EditOfferLetterDialog;
